/**
 * Collection infinite scroll — loads ONE next page when near the bottom.
 * Does not chain/auto-loop extra pages.
 */
(function () {
  if (window.__collectionInfiniteScrollBound) return;
  window.__collectionInfiniteScrollBound = true;

  var state = {
    el: null,
    grid: null,
    sentinel: null,
    spinner: null,
    sectionId: '',
    nextUrl: '',
    loading: false,
    done: false,
    ticking: false,
    // After a load, ignore scroll triggers until user scrolls again
    armed: true,
    lastScrollY: 0,
    io: null
  };

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function bind(root) {
    var el = $('collection-infinite-scroll', root) || $('collection-infinite-scroll');
    if (!el) return false;

    state.el = el;
    state.grid = document.getElementById('product-grid');
    state.sentinel = $('[data-infinite-sentinel]', el);
    state.spinner = $('[data-infinite-spinner]', el);
    state.sectionId = el.getAttribute('data-section-id') || '';
    state.nextUrl = el.getAttribute('data-next-url') || '';
    state.loading = false;
    state.done = !state.nextUrl;
    state.armed = true;
    state.lastScrollY = window.scrollY || 0;

    if (!state.grid || !state.nextUrl) {
      el.setAttribute('hidden', '');
      state.done = true;
      return false;
    }

    el.removeAttribute('hidden');
    var btn = $('[data-infinite-button]', el);
    if (btn) btn.setAttribute('hidden', '');
    return true;
  }

  function setLoading(on) {
    state.loading = on;
    if (state.spinner) state.spinner.hidden = !on;
  }

  function buildFetchUrl(url) {
    var u = new URL(url, window.location.origin);
    if (state.sectionId) u.searchParams.set('section_id', state.sectionId);
    return u.toString();
  }

  function finish() {
    state.done = true;
    state.nextUrl = '';
    if (state.el) {
      state.el.setAttribute('data-next-url', '');
      state.el.setAttribute('hidden', '');
    }
    setLoading(false);
  }

  /**
   * Near bottom = sentinel within ~1 viewport of the visible area
   * (about the last 2–3 product rows on mobile), not far ahead.
   */
  function shouldLoad() {
    if (state.done || state.loading || !state.nextUrl || !state.armed) return false;

    var marker = state.sentinel || state.el;
    if (!marker) return false;

    var rect = marker.getBoundingClientRect();
    var viewH = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewH * 1.15;
  }

  function loadNext() {
    if (state.done || state.loading || !state.nextUrl || !state.armed) return;

    // Disarm until the user scrolls down again after this page loads
    state.armed = false;
    setLoading(true);

    fetch(buildFetchUrl(state.nextUrl), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load page');
        return res.text();
      })
      .then(function (htmlText) {
        var doc = new DOMParser().parseFromString(htmlText, 'text/html');
        var nextGrid = doc.getElementById('product-grid');
        var nextLoader = doc.querySelector('collection-infinite-scroll');

        if (nextGrid && state.grid) {
          Array.prototype.forEach.call(nextGrid.children, function (item) {
            state.grid.appendChild(document.importNode(item, true));
          });
        }

        var newNext = nextLoader ? nextLoader.getAttribute('data-next-url') || '' : '';
        state.nextUrl = newNext;
        if (state.el) state.el.setAttribute('data-next-url', newNext);

        if (newNext) {
          try {
            var page = new URL(newNext, window.location.origin).searchParams.get('page');
            if (page) {
              var cur = new URL(window.location.href);
              cur.searchParams.set('page', page);
              window.history.replaceState({}, '', cur.toString());
            }
          } catch (e) {}
        } else {
          finish();
          return;
        }
      })
      .catch(function (err) {
        console.error('[collection-infinite-scroll]', err);
        // Allow retry on next scroll if a request failed
        state.armed = true;
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function onScrollOrResize() {
    if (state.ticking || state.done) return;
    state.ticking = true;
    requestAnimationFrame(function () {
      state.ticking = false;

      var y = window.scrollY || 0;
      // Re-arm only after the user scrolls downward a bit past the last load
      if (!state.armed && !state.loading && y > state.lastScrollY + 80) {
        state.armed = true;
      }
      state.lastScrollY = y;

      if (shouldLoad()) loadNext();
    });
  }

  function attachScroll() {
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('touchmove', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
  }

  function boot(root) {
    if (state.io) {
      try { state.io.disconnect(); } catch (e) {}
      state.io = null;
    }
    if (!bind(root || document)) return;
    attachScroll();
    state.lastScrollY = window.scrollY || 0;
    // One check on boot only if already at bottom (e.g. restored scroll)
    setTimeout(function () {
      if (shouldLoad()) loadNext();
    }, 150);
  }

  function patchFacets() {
    if (!window.FacetFiltersForm || !FacetFiltersForm.renderProductGridContainer) return;
    if (FacetFiltersForm.__infinitePatched) return;
    FacetFiltersForm.__infinitePatched = true;
    var prev = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      prev.call(FacetFiltersForm, html);
      boot(document.getElementById('ProductGridContainer') || document);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
      patchFacets();
    });
  } else {
    boot(document);
    patchFacets();
  }

  document.addEventListener('shopify:section:load', function () { boot(document); });
  setTimeout(patchFacets, 400);
  setTimeout(patchFacets, 1200);
})();
